import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { isMobile } from 'react-device-detect';
import { Breakpoints } from '../../utils';
import { arrowleftIcon, arrowrightIcon } from '../../images';
import StyledCarousel from './CarouselSlider.style';

// avoid passing currentSlide and slideCount down to the component otherwise it will display warnings
// eslint-disable-next-line
const SlickArrow = ({ currentSlide, slideCount, children, alt, ...rest }) => (
  <img alt={alt} {...rest}>
    {children}
  </img>
);

const DEFAULT = {
  dots: true,
  arrows: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <SlickArrow src={arrowrightIcon} alt="next" />,
  prevArrow: <SlickArrow src={arrowleftIcon} alt="previous" />,
  responsive: [
    {
      breakpoint: Breakpoints.computerBreakpoint,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: Breakpoints.wideMobileBreakpoint,
      settings: {
        centerMode: true,
        centerPadding: '32px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const CarouselSlider = ({ children, height, theme, options = {} }) => {
  const settings = { ...DEFAULT, ...options };

  // disable auto play on mobile
  if (isMobile) {
    settings.autoplay = false;
  }

  const sliderCSS = cn(
    'carouselslider',
    theme && `carouselslider--${theme}`,
    { 'carouselslider--align': height === 'align' },
    { 'carouselslider--arrows': settings.arrows }
  );
  return (
    <StyledCarousel {...settings} height={height} className={sliderCSS}>
      {children}
    </StyledCarousel>
  );
};

CarouselSlider.propTypes = {
  children: PropTypes.node,
  height: PropTypes.string,
  theme: PropTypes.string,
  options: PropTypes.object
};
CarouselSlider.defaultProps = {
  height: 'align'
};
export default CarouselSlider;
